// src/components/Navbar.tsx
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Car } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Domov', path: '/' },
    { name: 'O nas', path: '/o-nas' },
    { name: 'Avtoservis', path: '/avtoservis' },
    { name: 'Obnova turbo polnilnikov', path: '/obnova-turbo' },
    { name: 'Kontakt', path: '/kontakt' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <nav className={`fixed w-full z-50 transition-all duration-500 ${isScrolled ? 'bg-white shadow-md py-2' : 'bg-white/90 py-4'}`}>
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex items-center space-x-2 group">
            <Car size={28} className="text-autoBlue group-hover:text-autoTeal transition-colors duration-300" />
            <span className="text-2xl font-bold text-autoBlue group-hover:text-autoTeal transition-colors duration-300">Avtoservis Vodnik</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-3">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className={`nav-link transition-all duration-300 ${location.pathname === link.path ? 'active' : ''}`}
              >
                {link.name}
              </Link>
            ))}
            <a href="tel:041273738" className="flex items-center text-white bg-autoRed px-4 py-2 rounded-full hover:bg-red-600 transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-1">
              <Phone size={18} className="mr-2" />
              041 273 738
            </a>
          </div>

          {/* Mobile Navigation Toggle */}
          <button className="md:hidden bg-autoBlue text-white p-2 rounded-full" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation Menu */}
        {isOpen && (
          <div className="md:hidden mt-4 pb-4 animate-slide-in bg-white rounded-xl shadow-lg">
            <div className="flex flex-col space-y-2 p-2">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className={`nav-link ${location.pathname === link.path ? 'active' : ''} w-full text-center`}
                  onClick={() => setIsOpen(false)}
                >
                  {link.name}
                </Link>
              ))}
              <a href="tel:041273738" className="flex items-center justify-center text-white bg-autoRed px-4 py-2 rounded-full">
                <Phone size={18} className="mr-2" />
                041 273 738
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;